import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSearchModal } from '../contexts/SearchContext';
import './Header.css';

const Header = () => {
  const [isMediaDropdownOpen, setIsMediaDropdownOpen] = useState(false);
  const [dropdownTimeout, setDropdownTimeout] = useState(null);
  const { openModal } = useSearchModal();

  const handleMouseEnter = () => {
    if (dropdownTimeout) {
      clearTimeout(dropdownTimeout);
      setDropdownTimeout(null);
    }
    setIsMediaDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    const timeout = setTimeout(() => {
      setIsMediaDropdownOpen(false);
    }, 300);
    setDropdownTimeout(timeout);
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <Link to="/" className="logo-link">
            <img 
              src="/logo_horizontal.png" 
              alt="Rayad Group" 
              className="header-logo-img"
            />
          </Link>
        </div>
        
        <nav className="main-nav">
          <ul className="nav-list">
            <li className="nav-item">
              <Link to="/" className="nav-link">HOME</Link>
            </li>
            <li className="nav-item">
              <Link to="/portfolio" className="nav-link">PORTFOLIO</Link>
            </li>
            <li className="nav-item">
              <Link to="/about" className="nav-link">ABOUT</Link>
            </li>
            <li className="nav-item dropdown" 
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}>
              <span className="nav-link dropdown-toggle">MEDIA</span>
              {isMediaDropdownOpen && (
                <div className="dropdown-menu"
                     onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave}>
                  <Link to="/media/news" className="dropdown-link">News Articles</Link>
                  <Link to="/media/events" className="dropdown-link">Events &amp; Speaking</Link>
                  <Link to="/media/videos" className="dropdown-link">Videos</Link>
                  <Link to="/global-media-coverage" className="dropdown-link">Global Media Coverage</Link>
                </div>
              )}
            </li>
            <li className="nav-item">
              <Link to="/contact" className="nav-link">CONTACT</Link>
            </li>
          </ul>
        </nav>
        
        <div className="header-actions">
          <button 
            className="search-btn" 
            onClick={openModal}
            title="Search (Ctrl+K)"
            aria-label="Open search"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M7.333 12.667A5.333 5.333 0 1 0 7.333 2a5.333 5.333 0 0 0 0 10.667ZM14 14l-2.9-2.9" 
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;